<template>
    <el-drawer title="数据详情" :visible.sync="drawerShow" :wrapperClosable="true"
        :destroy-on-close="true" size="100%" @close="close" v-loading="dataLoading">
        <div class="drawer-content" >
			<div class="page-tabs-box">
				<el-tabs v-model="tabActiveName">
					<el-tab-pane
						label="TDC短链数据"
						name="1"
					>
					<template v-if="details">
						<div>
							<el-card class="box-card" >
								<div class="tdc">TDC 短链接: <small class="fr font10">快链访问数据每小时更新一次</small></div>
								<div class="shortUrl color-blue" v-if="data">{{data.shortUrl}} <span class="ML10"><el-button size="mini" round @click="copy(data.shortUrl)">复制</el-button></span></div>
								<div class="url" v-if="data">原始链接：{{data.ulr}}</div>
								<input class="copyTool" ref="copyTool" :value="copyUrl" />
							</el-card>
						</div>
						<el-row :gutter="5" class="auditTotalNum">
							<el-col :span="5">
								<el-card>
									<router-link to="/user/userAuth/list?claimStatus=1">
										<div class="title">总访问<small>(pv/uv)</small>：</div>
										<div class="num clearfix">
											<span class="color-danger" v-if="details">{{details.totalUvPv.pv}}</span> / <span class="color-blue">{{details.totalUvPv.uv}}</span>
										</div>
									</router-link>
								</el-card>
							</el-col>
							<el-col :span="5">
								<el-card>
									<router-link to="/user/userAuth/list?claimStatus=1">
										<div class="title">最近24小时访问<small>(pv/uv)</small>：</div>
										<div class="num clearfix">
											<span class="color-danger">{{details.totalUvPv0.pv}}</span> / <span class="color-blue">{{details.totalUvPv0.uv}}</span>
										</div>
									</router-link>
								</el-card>
							</el-col>
							<el-col :span="5">
								<el-card>
									<router-link to="/user/userAuth/list?claimStatus=1">
										<div class="title">前一天访问<small>(pv/uv)</small>：</div>
										<div class="num clearfix">
											<span class="color-danger">{{details.totalUvPv1.pv}}</span> / <span class="color-blue">{{details.totalUvPv1.uv}}</span>
										</div>
									</router-link>
								</el-card>
							</el-col>
							<el-col :span="5">
								<el-card>
									<router-link to="/user/userAuth/list?claimStatus=1">
										<div class="title">最近7天访问<small>(pv/uv)</small>：</div>
										<div class="num clearfix">
											<span class="color-danger">{{details.totalUvPv7.pv}}</span> / <span class="color-blue">{{details.totalUvPv7.uv}}</span>
										</div>
									</router-link>
								</el-card>
							</el-col>
							<el-col :span="4">
								<el-card>
									<router-link to="/user/userAuth/list?claimStatus=1">
										<div class="title">最近30天访问<small>(pv/uv)</small>：</div>
										<div class="num clearfix">
											<span class="color-danger">{{details.totalUvPv30.pv}}</span> / <span class="color-blue">{{details.totalUvPv30.uv}}</span>
										</div>
									</router-link>
								</el-card>
							</el-col>
						</el-row>
						<el-card class="MT20">
							<div slot="header" class="card-header">
								<div>最近访问趋势:</div>
								<div>
									<el-button type="text" @click="drawChart(1)"><span :class="[idx == 1 ? 'color-warning' : '']">总访问数</span></el-button>
									<el-button type="text" @click="drawChart(2)"><span :class="[idx == 2 ? 'color-warning' : '']">24小时</span></el-button>
									<el-button type="text" @click="drawChart(3)"><span :class="[idx == 3 ? 'color-warning' : '']">前一天</span></el-button>
									<el-button type="text" @click="drawChart(4)"><span :class="[idx == 4 ? 'color-warning' : '']">7天</span></el-button>
									<el-button type="text" @click="drawChart(5)"><span :class="[idx == 5 ? 'color-warning' : '']">30天</span></el-button>
								</div>					    
							</div>
							<div id="visit" ref="visit"></div>
						</el-card>
						<el-row :gutter="5" class="MT20">
							<el-col :span="12">
								<el-card header="访问终端分布:">
									<div id="terminal" ref="terminal"></div>
								</el-card>
							</el-col>
							<el-col :span="12">
								<el-card header="访问应用分布:">
									<div id="appName" ref="appName"></div>
								</el-card>
							</el-col>
						</el-row>
						<el-row class="MT20">
							<el-card>
								<div slot="header" class="card-header">
									<div>访问地区分布:</div>
									<div>
										<el-button type="text" @click="drawChart3(1)"><span :class="[index == 1 ? 'color-warning' : '']">按省份</span></el-button>
										<el-button type="text" @click="drawChart3(2)"><span :class="[index == 2 ? 'color-warning' : '']">按城市</span></el-button>
									</div>					    
								</div>
								<div id="area" ref="area"></div>					
							</el-card>				
						</el-row>
					</template>
					</el-tab-pane>
					<el-tab-pane
						v-if="$utils.have('/tdc/cardList') && data"
						label="短链下单数据"
						name="2"
					>
						<order-details :shortUrl="data.shortUrl"></order-details>
					</el-tab-pane>
				</el-tabs>
			</div>
			
        </div>
        <!-- <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div> -->
    </el-drawer>
</template>
<script>
import { Chart } from '@antv/g2';
import { DualAxes } from '@antv/g2plot';
import { Pie } from '@antv/g2plot';
import OrderDetails from './order-details.vue';
export default {    
	components:{OrderDetails},
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            data:null,
			details:null,
			chart:null,			
			index:1,
			idx:1,
			copyTimer: null,
			copyUrl: "",
			tabActiveName: "1"
        }
    },
    methods: {
        close() {           
            this.drawerShow = false;
        },
        show(data) {			
            if (data) {
				this.data = data
				this.getData()
            }
			this.tabActiveName = "1";			
            this.drawerShow = true;
        },
        getData(){			
            this.dataLoading = true;
			this.$request({
			       url: "/tdc/detail",
			       method: "POST",
			       params: {
					   shortUrl:this.data.shortUrl
			       },
			   })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result ) {
					this.details = result;					
					this.$nextTick(() => {
						this.drawChart(1)
						this.drawChart1()
						this.drawChart2()
						this.drawChart3(1)
					})
				} else {
					this.$message.error(msg || "请求失败");
				}
			})			
			.finally(() => {
				this.dataLoading = false;
			});
		},
		copy(url){
		    clearTimeout(this.copyTimer);
		    this.copyUrl = url;
		    this.copyTimer = setTimeout(() => {
		        const e = this.$refs.copyTool;
		        e.select();
		        document.execCommand("Copy"); // 执行浏览器复制命令
		        this.$message.success("已复制成功，可粘贴");
		    },300)
		},
		drawChart(type){
			this.idx = type	
			if( this.dualAxes ) this.dualAxes.destroy();
			var data = []
			if( type == 1 ){				
				data = this.details.visits ? [...this.details.visits] : [];
			}else if( type ==2 ){				 
				data = this.details.visits0 ? [...this.details.visits0] : [];
			}
			else if( type ==3 ){
				data = this.details.visits1 ? [...this.details.visits1] : [];
			}
			else if( type ==4 ){
				data = this.details.visits7 ? [...this.details.visits7] : [];
			}else{
				data = this.details.visits30 ? [...this.details.visits30] : [];
			}
			this.dualAxes = new DualAxes('visit', {
			  data: [data, data],
			  xField: 'date',
			  yField: ['pv', 'uv'],
			   height:200,
			  geometryOptions: [
			    {
			      geometry: 'line',
			      color: '#5B8FF9',
			    },
			    {
			      geometry: 'line',
			      color: '#5AD8A6',
			    },
			  ],
			});			
			this.dualAxes.render();
		},
		drawChart1(){
			var data = [];
				data = [...this.details.os];				
				const piePlot = new Pie('terminal', {
					appendPadding: 10,
					data,
					angleField: 'rate',
					colorField: 'name',
					radius: 1,
					innerRadius: 0.4,
					height:200,
					label: {
						type: 'inner',
						offset: '-50%',
						// content: '{value}',
						content: ({ percent }) => `${(percent * 100).toFixed(2)}%`,
						style: {
							textAlign: 'center',
							fontSize: 12,
						},
					},
					interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
					statistic: {
						title: false,
						content: {
						style: {
							whiteSpace: 'pre-wrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						},
						content: '',
						
						},
					},
					tooltip:{
						// fields: ['name', 'rate'],
						formatter: (datum) => {
							return { name: datum.name, value: `${(datum.rate * 100).toFixed(2)}%` };
						},
					}
				});				
				piePlot.render();
		},
		drawChart2(){
			var data = [];
				data = [...this.details.apps];			
			
			const piePlot = new Pie('appName', {
				appendPadding: 10,
				data,
				angleField: 'rate',
				colorField: 'name',
				radius: 0.9,
				height:200,
				label: {
					type: 'inner',
					offset: '-30%',
					content: ({ percent }) => `${(percent * 100).toFixed(2)}%`,
					style: {
						fontSize: 12,
						textAlign: 'center',
					},
				},
				interactions: [{ type: 'element-active' }],
				tooltip:{
					// fields: ['name', 'rate'],
					formatter: (datum) => {
						return { name: datum.name, value: `${(datum.rate * 100).toFixed(2)}%` };
					},
				}
			});
			
			piePlot.render();
		},
		drawChart3(type){
			this.index = type
			if( this.chart ) this.chart.destroy();
			var _data = []
			if( type ==1 ){
				
				_data = this.details.provinces ? [...this.details.provinces] : [];
			}else{
				 
				_data = this.details.cities ? [...this.details.cities] : [];
			}
			
			_data.map( v => {
			    v.amount = parseFloat(v.visit);
			})
			this.chart = new Chart({
			    container: 'area',
			    autoFit: true,
			    height: 120,
			});
			this.chart.data(_data);
			this.chart.interaction('active-region');    
			
			this.chart.tooltip({
			    showTitle: false,
			    showMarkers: false,
			});
			
			this.chart
			    .interval()				
			    .position('name*amount')			   
			    .tooltip('name*amount', (name, amount) => {
			        amount = parseFloat(amount);
			        return {
			            name: name,
			            value: amount,
			        };
			    });
				
			this.chart.render();
		}
			
        
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer{
	max-width: 90%;
}
.font10{
	font-size: 10px;
}
.tdc{
	font-size: 16px;
	font-weight: bold;
}
.shortUrl{
	margin-top: 15px;
}
.url{
	margin-top: 5px;
	color:#999
}
::v-deep .el-card__body{
	padding:10px
}
.auditTotalNum{
	margin-top: 20px;
	.title{
		
		font-weight: bold;
		small{
			color:#999
		}
	}
    .num{
        margin-top: 10px;
		color:#999;
        .color-danger{            
            font-size: 18px;            
        }
		.color-blue{
			font-size: 14px;
		}
    }
}
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}

.card-header{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>